module.exports = __webpack_public_path__ + "media/src/images/icons/gray-fill-checkmark-square-d175bd6d1dcac0f50b5eef61554dfb20.svg";